import { Col, Form, FormInstance, Row, Select } from "antd";
import { IsOpenType } from "interfaces/events";
import { EditEventFormType } from "../CreateOrEditEvent";
import CompanyCard from "./CompanyCard";

const { Option } = Select;

interface Props {
  form: FormInstance<EditEventFormType>;
}

const CompanyCardStatus: React.FC<Props> = ({ form }) => {
  const onVisibilityChange = (value: number) => {
    form.setFieldsValue({ is_visible: value });
  };

  const onStatusChange = (value: number) => {
    form.setFieldsValue({ is_open: value });
  };

  return (
    <CompanyCard title="Status">
      <Row gutter={[30, 30]}>
        <Col md={12} xs={24}>
          <Form.Item<EditEventFormType> name="is_open" label="Status">
            <Select onChange={onStatusChange} size="large" style={{ width: "98%" }}>
              <Option value={IsOpenType.NOT_OPENED}>Ikke åpnet</Option>
              <Option value={IsOpenType.OPENED}>Åpen</Option>
              <Option value={IsOpenType.CLOSED}>Stengt</Option>
              <Option value={IsOpenType.DEREGISTERING_CLOSED}>Avmelding Stengt</Option>
            </Select>
          </Form.Item>
        </Col>

        <Col md={12} xs={24}>
          <Form.Item<EditEventFormType> name="is_visible" label="Synlighet">
            <Select onChange={onVisibilityChange} size="large" style={{ width: "98%" }}>
              <Option value={0}>Ikke synlig</Option>
              <Option value={1}>Synlig på nettside</Option>
              <Option value={2}>Synlig i app</Option>
              <Option value={3}>Synlig overalt</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </CompanyCard>
  );
};

export default CompanyCardStatus;
